import React, { createContext, useContext } from 'react'
import { SupportedFileWithMetadata } from 'APP/Converse/FilePreview/types'

type FileUploadContextProps = {
  title?: string
  errorMessage?: string
  isError: boolean
  onPress?: (fileIndexToReplace?: number) => void
  testId: string
  files: SupportedFileWithMetadata[]
  maxFiles: number
  onRemove?: (file: SupportedFileWithMetadata, index: number) => void
  isLoading: boolean
  allowMultiple: boolean
}

type FileUploadProviderProps = {
  children: React.ReactNode
  title?: string
  errorMessage?: string
  onPress?: (fileIndexToReplace?: number) => void
  testId: string
  files?: SupportedFileWithMetadata[]
  maxFiles?: number
  onRemove?: (file: SupportedFileWithMetadata, index: number) => void
  isLoading?: boolean
  allowMultiple?: boolean
}

const FileUploadContext = createContext<FileUploadContextProps | undefined>(undefined)

export const useFileUpload = () => {
  const context = useContext(FileUploadContext)
  if (!context) throw new Error('useFileUpload must be used within a FileUploadContext')
  return context
}

export const FileUploadProvider: React.FC<FileUploadProviderProps> = ({
  children,
  title = '',
  errorMessage,
  onPress,
  testId,
  files = [],
  maxFiles = 1,
  onRemove,
  isLoading = false,
  allowMultiple = false,
}) => {
  const normalizedMaxFiles = Number.isFinite(maxFiles) && maxFiles > 0 ? Math.floor(maxFiles) : 1
  const effectiveMaxFiles = allowMultiple ? normalizedMaxFiles : 1

  return (
    <FileUploadContext.Provider
      value={{
        title,
        errorMessage: errorMessage,
        isError: !!errorMessage,
        onPress,
        testId,
        files,
        maxFiles: effectiveMaxFiles,
        onRemove,
        isLoading,
        allowMultiple,
      }}
    >
      {children}
    </FileUploadContext.Provider>
  )
}
